"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Select component - dropdown select with options
 */
const react_1 = require("react");
require("../../styles/components/select.scss");
/**
 * Select component with label, error, and helper text support
 * @param props - SelectProps
 * @param ref - Forwarded ref to the select element
 * @returns Select component
 */
exports.Select = (0, react_1.forwardRef)((_a, ref) => {
    var { label, error, helperText, fullWidth = false, className = '', id, disabled = false, required = false, options, placeholder } = _a, rest = __rest(_a, ["label", "error", "helperText", "fullWidth", "className", "id", "disabled", "required", "options", "placeholder"]);
    // Warn in development if options array is empty
    if (options.length === 0 && process.env.NODE_ENV !== 'production') {
        console.warn('Select component received empty options array');
    }
    const containerClasses = ['select-container', fullWidth ? 'select-container--full-width' : '']
        .filter(Boolean)
        .join(' ');
    const selectClasses = ['select', error ? 'select--error' : '', disabled ? 'select--disabled' : '', className]
        .filter(Boolean)
        .join(' ');
    return ((0, jsx_runtime_1.jsxs)("div", { className: containerClasses, children: [label && ((0, jsx_runtime_1.jsxs)("label", { htmlFor: id, className: "select__label", children: [label, required && (0, jsx_runtime_1.jsx)("span", { className: "select__label--required", "aria-hidden": "true" })] })), (0, jsx_runtime_1.jsxs)("select", Object.assign({ ref: ref, id: id, className: selectClasses, disabled: disabled, required: required, "aria-invalid": error ? 'true' : 'false', "aria-describedby": error ? `${id}-error` : helperText ? `${id}-helper` : undefined }, rest, { children: [placeholder && ((0, jsx_runtime_1.jsx)("option", { value: "", disabled: true, children: placeholder })), options.map((option) => ((0, jsx_runtime_1.jsx)("option", { value: option.value, disabled: option.disabled, children: option.label }, option.value)))] })), error && ((0, jsx_runtime_1.jsx)("span", { id: `${id}-error`, className: "select__error", role: "alert", children: error })), helperText && !error && ((0, jsx_runtime_1.jsx)("span", { id: `${id}-helper`, className: "select__helper", children: helperText }))] }));
});
exports.Select.displayName = 'Select';
exports.default = exports.Select;
